import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'session-taken',
    templateUrl: './sessiontaken.component.html'
})
export class SessionTakenComponent extends BaseComponent{
    constructor(private route: ActivatedRoute) {
        super(route)
    }
}
